var _rect, _rect2, _rect3, _circle, _circle2, _circle3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdfBundlePreview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 340",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 282,
    y: 34,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#FFB628",
    transform: "rotate(-14 288 40)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 292,
    y: 232,
    width: 13,
    height: 13,
    rx: 2,
    fill: "#fe79a7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 252,
    width: 11,
    height: 11,
    rx: 2,
    fill: "#2C46B2",
    transform: "rotate(22 29 257)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 146,
    r: 6,
    fill: "#2C46B2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 176,
    r: 5,
    fill: "#FFB628"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 96,
    r: 5,
    fill: "#FFFFFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 40,
    width: 164,
    height: 226,
    rx: 14,
    fill: "#2C46B2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 58,
    width: 164,
    height: 226,
    rx: 14,
    fill: "#fe79a7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 76,
    width: 164,
    height: 226,
    rx: 14,
    fill: "#FFFFFF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 104,
    width: 70,
    height: 10,
    rx: 5,
    fill: "#2C46B2"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 124,
    width: 46,
    height: 8,
    rx: 4,
    fill: "#B6C7F2"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 156,
    width: 120,
    height: 7,
    rx: 3.5,
    fill: "#DFE4FC"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 172,
    width: 104,
    height: 7,
    rx: 3.5,
    fill: "#DFE4FC"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 188,
    width: 114,
    height: 7,
    rx: 3.5,
    fill: "#DFE4FC"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 220,
    width: 18,
    height: 52,
    rx: 4,
    fill: "#4D7BF3"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 238,
    width: 18,
    height: 34,
    rx: 4,
    fill: "#fe79a7"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 210,
    width: 18,
    height: 62,
    rx: 4,
    fill: "#29CCC7"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 230,
    width: 18,
    height: 42,
    rx: 4,
    fill: "#FFB628"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117 80V128a9 9 0 0 1-18 0V50a13.5 13.5 0 0 1 27 0V134a18 18 0 0 1-36 0V70",
    stroke: "#182033",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfBundlePreview);
export default __webpack_public_path__ + "static/media/pdf-bundle-preview.f1efb76f092db4716010ef0cde4e667c.svg";
export { ForwardRef as ReactComponent };